import React, { useEffect, useState, useRef, useCallback } from 'react';
import '../../../styles/myTeamsStyle.css';
import "../../../styles/businessDashboardStyle.css";
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import addMember from '../../../assets/person_add.svg';
import { FiMoreVertical } from 'react-icons/fi';
import Loader from '../../Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { getTeam } from '../../services/operations/teamAPI';
import AddTeam from './AddTeam';
import ActionPopup from './ActionPopup';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import post1 from '../../../assets/post1.png'
import post2 from '../../../assets/post2.png'
import post3 from '../../../assets/post3.png'
import { message } from '../../messages/Message';

const Team = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [result, setResult] = useState([]);
  const [teamStats, setTeamStats] = useState([]);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [prefilledEmail, setPrefilledEmail] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupOption, setShowPopupOption] = useState(false);
  const [selectedAction, setSelectedAction] = useState({});
  const [currentFilter, setCurrentFilter] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editMember, setEditMember] = useState(null);
  const [timeFilter, setTimeFilter] = useState("year");
  const [profileImages, setProfileImages] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.profile.user);
  const observer = useRef();
  const dropdownRefs = useRef(new Map());



  const listTeam = async (pageNum = 1, filter = null, filterType = null) => {
    if (isFetching) return;

    setIsFetching(true);

    const response = await dispatch(getTeam(token, pageNum, filter, filterType));

    if (response?.data) {
      const { data, role_counts, pagination } = response.data;

      const mappedTeam = data.map((member) => ({
        id: member.id,
        name: member.name,
        email: member.email,
        lastLogin: member.last_login,
        profilePic: member.profile_image
          ? member.profile_image
          : `https://api.dicebear.com/5.x/initials/svg?seed=${member.name}`,
        //role: member.roles[0]?.display_name,
        roles: member.roles.map(role => role.display_name),
        role: member.roles.map(role => role.name),
        invited: member.invited,
        status: member.status
      }));
      setResult((prev) => (pageNum === 1 ? mappedTeam : [...prev, ...mappedTeam]));

      const allImages = mappedTeam.map(member => member.profilePic);
      setProfileImages((prev) =>
        pageNum === 1 ? allImages : [...prev, ...allImages]
      );

      const mappedStats = [
        { type: "All Members", count: response.data.total_members, role: null },
        { type: "Hiring Managers", count: role_counts["hiring-manager"] || 0, role: "hiring-manager" },
        { type: "Recruiters", count: role_counts["recruiter"] || 0, role: "recruiter" },
        { type: "Team Members", count: role_counts["team-member"] || 0, role: "team-member" }
      ].filter(item => item.role !== "business-admin");

      setTeamStats(mappedStats);
      setHasMore(pagination.current_page < pagination.last_page);
      setOpenDropdown(null)
    }

    setIsFetching(false);
  };

  useEffect(() => {
    setCurrentFilter(null);
    setPage(1);
    listTeam(1);
  }, []);

  const handleStatusFilter = (role) => {
    setCurrentFilter(role);
    setPage(1);
    listTeam(1, role, timeFilter);
  };

  const clearFilter = () => {
    setCurrentFilter(null);
    setPage(1);
    listTeam(1);
  };

  const handleDropdownToggle = (index, event) => {
    if (openDropdown === index) {
      setOpenDropdown(null);
      return;
    }

    const iconRect = event.currentTarget.getBoundingClientRect();

    setDropdownPosition({
      top: iconRect.bottom - 20 + window.scrollY,
      left: iconRect.left - 120 + window.scrollX,
    });

    setOpenDropdown(index);
  };

  const handleDropdownOptionClick = (action, desc, id, role, member) => {
    setSelectedAction({ action, desc, id, role });
    setShowPopupOption(true);
    setOpenDropdown(null);
  };

  const handleAddClick = () => {

    if(!user?.is_premium){
      toast.error(message.subscribeMessage)
      navigate("/business-dashboard/subscription")
    }
    if (email.trim() && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      setEmailError('');
      setPrefilledEmail(email);
      setEditMember(null);
      setEditMode(false);
      setShowPopup(true);
      setEmail('');

      setCurrentFilter(null);
      setPage(1);
      setHasMore(true);
      listTeam(1, null, timeFilter);
    } else {
      setEmailError('Invalid email format');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleAddClick();
    }
  };

  const handleInviteClick = () => {

    if(!user?.is_premium){
      toast.error(message.subscribeMessage)
      navigate("/business-dashboard/subscription")
    }
    setEmailError('');
    setPrefilledEmail('');
    setEditMember(null);
    setEditMode(false);
    setShowPopup(true);

    setCurrentFilter(null);
    setPage(1);
    setHasMore(true);
    listTeam(1, null, timeFilter);
  };

  const lastElementRef = useCallback(
    (node) => {
      if (loading || !hasMore) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => {
            const nextPage = prevPage + 1;
            listTeam(nextPage, currentFilter, timeFilter);
            return nextPage;
          });
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore, isFetching, currentFilter]
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      let isOutside = true;

      dropdownRefs.current.forEach((ref) => {
        if (ref && ref.contains(event.target)) {
          isOutside = false;
        }
      });

      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [result]);


  const handleEditClick = (member) => {
    setEditMember({
      id: member.id,
      name: member.name,
      email: member.email,
      roles: member.role,
    });
    setEditMode(true);
    setShowPopup(true);
    setOpenDropdown(null);
  };

  const handleTimeFilterChange = (event) => {
    setTimeFilter(event.target.value);
    listTeam(1, currentFilter, event.target.value)
  };

  return (
    <div className='teams-dashboard'>
      {loading && <Loader />}
      <div className='my-teams'>
        <div className='team-first'
          style={{
            width: user?.roles?.some(role => role.name === "business-admin") ? "50%" : "100%"
          }}
        >
          <p className='team-staut-heading'>Status</p>
          <div className="team-container">
            {teamStats.map((item, index) => (
              <div
                key={index}
                className={`team-box ${currentFilter === item.role ? 'active-filter' : ''}`}
                onClick={() => handleStatusFilter(item.role)}
              >
                <div className='team-content'>
                  <h3 className="team-name">{item.count}</h3>
                  <p className="team-count">{item.type}</p>
                </div>
                <span className="navigate-icon">{">"}</span>
              </div>
            ))}
          </div>
        </div>
        {user?.roles?.some(role => role.name === "business-admin") &&
          (
            <div className="team-second">
              <p className='team-add-heading'>Add Teams</p>
              <div className="team-controls">
                <div className="input-team-add">
                  <div className="input-group-team">
                    <input
                      type="text"
                      placeholder="Contact@example.com"
                      className="team-input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                    <button className="add-btn" onClick={handleAddClick}>Add</button>
                  </div>
                  <div className="error-container">
                    {emailError && <p className="error-message-team">{emailError}</p>}
                  </div>
                </div>

                <select
                  id="timeFilter"
                  name="timeFilter"
                  className='dropdown-filter-month'
                  value={timeFilter}
                  onChange={handleTimeFilterChange}
                >
                  <option value="yearly">Year</option>
                  <option value="monthly">Month</option>
                  <option value="weekly">Week</option>
                </select>

                <button className="invite-btn" onClick={handleInviteClick}>
                  <img src={addMember} alt="invite" width="20px" height="20px" />
                  Invite Member
                </button>
              </div>
              <div className='team-numbers'>
                {profileImages.slice(0, 3).map((img, index) => (
                  <img key={index} src={img} alt={`profile-${index}`} />
                ))}

                {profileImages.length > 3 && (
                  <p>+{profileImages.length - 3}</p>
                )}
              </div>

            </div>
          )}

      </div>
      <p className='team-my-team-member-detail'>My Teams</p>
      <div className="team-card-container">
        {result.length > 0 ? (
          result.map((member, index) => (
            <div key={index} className="team-card">
              <div className="card-header" ref={index === result.length - 1 ? lastElementRef : null}>
                {user?.roles?.some(role => role.name === "business-admin") && (
                  <>
                    <FiMoreVertical
                      className="more-icon"
                      onClick={(event) => handleDropdownToggle(index, event)}
                      ref={(el) => dropdownRefs.current.set(index, el)}
                    />
                    {openDropdown === index && (
                      <div className="dropdown-menu"
                        style={{
                          position: 'absolute',

                          zIndex: 999
                        }}
                        onMouseDown={(e) => e.stopPropagation()}  >
                        {member.status === "suspended" ? (
                          <>
                            <p
                              onClick={() => handleDropdownOptionClick("Revoke", "Are you sure you want to revoke suspension for this member?", member.id, member.role, member)}
                              style={{ color: "black", cursor: "pointer" }}
                            >
                              Revoke Suspension
                            </p>
                            <p
                              onClick={() => handleDropdownOptionClick("Remove", "Are you sure you want to remove this member, this action cannot be undone.", member.id, member.role, member)}
                              style={{ color: "black", cursor: "pointer" }}
                            >
                              Remove
                            </p>
                          </>
                        ) : (
                          <>
                            <p
                              onClick={() => handleDropdownOptionClick("Admin", "Are you sure you want to make this member as business admin, this action cannot be undone.", member.id, member.role, member)}
                              style={{ color: "black", cursor: "pointer" }}
                            >
                              Make Admin
                            </p>
                            <p
                              onClick={() => handleDropdownOptionClick("Remove", "Are you sure you want to remove this member, this action cannot be undone.", member.id, member.role, member)}
                              style={{ color: "black", cursor: "pointer" }}
                            >
                              Remove
                            </p>
                            <p
                              onClick={() => handleDropdownOptionClick("Suspend", "Are you sure you want to suspend this member, this action cannot be undone.", member.id, member.role, member)}
                              style={{ color: "black", cursor: "pointer" }}
                            >
                              Suspend
                            </p>
                            <p
                              onClick={() => handleEditClick(member)}
                              style={{ color: "black", cursor: "pointer" }}
                            >
                              Edit
                            </p>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>

              <div className="profile-pic">
                <img src={member.profilePic} alt={member.name} />
              </div>

              <h3 className="team-member-name">
                {member.name}&nbsp;
                <span className='team-member-invited'>{member.invited ? "invited" : ""}</span>
                <span className='team-member-invited'>{member.status === "suspended" ? member.status : ""}</span>
              </h3>
              <p className="team-member-designation">
                <span>{member.roles[0]}</span>
                {member.roles.length > 1 && (
                  <>
                    <span
                      data-tooltip-id={`roles-tooltip-${index}`}
                      data-tooltip-content={member.roles.slice(1).join(', ')}
                      className="remaining-roles"
                      style={{ cursor: "pointer" }}
                    >
                      +{member.roles.length - 1}
                    </span>
                    <Tooltip id={`roles-tooltip-${index}`} style={{ borderRadius: "8px", backgroundColor: " rgba(45, 118, 253, 1)" }} />
                  </>
                )}
              </p>
              <p className="team-member-login">Last Login: {member.lastLogin}</p>

              <div className="team-stats">
                <div className="stat">
                  <p className="stat-label">Job Postings</p>
                  <p className="stat-value">{"0"}</p>
                </div>
                <div className="stat">
                  <p className="stat-label">Calls</p>
                  <p className="stat-value">{"0"}</p>
                </div>
                <div className="stat">
                  <p className="stat-label">Hires</p>
                  <p className="stat-value">{"0"}</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="no-team-message">
            No Team Member Found
          </p>
        )}

      </div>

      {showPopup && <AddTeam prefilledEmail={prefilledEmail} onClose={() => setShowPopup(false)} listTeam={listTeam} isEditMode={editMode}
        editMember={editMember} />}
      {showPopupOption && <ActionPopup setPage={setPage} selectedAction={selectedAction} action={selectedAction.action} desc={selectedAction.desc} onClose={() => setShowPopupOption(false)} listTeam={listTeam} />}
    </div>
  );
};

export default Team;